import { AbstractDataFilter } from './abstract-data-filter';
import { EmployeesDataSource } from './../../data-sources/sources/employees-data-source';
import { EmployeeDataType } from './../../data-sources/sources/employees-data-source';

import * as ol from 'openlayers';

declare interface OpenlayersLocation {
    x: number; // all in openlayers coordinates!
    y: number;
}

export declare interface DataLocationFilterParameters {
    circleOL: { x: number; y: number; radius: number }; // all in openlayers coordinates for calculations.
    circle: { lat: number; lng: number; kilometers: number }; // understandable coordinates for UI.
    enabled: boolean;
}

export class DataLocationFilter extends AbstractDataFilter {
    private dataIdToOpenlayersLocation: OpenlayersLocation[] = [];

    constructor(private source: EmployeesDataSource) {
        super();
        this.source.data.forEach(el => {
            let coor = ol.proj.transform([el.Longitude, el.Latitude], 'EPSG:4326', 'EPSG:3857');
            this.dataIdToOpenlayersLocation[el._internal_datasource_id_] = {
                x: coor[0],
                y: coor[1]
            };
        });
    }

    protected executeInternal(ops: DataLocationFilterParameters) {
        this.anyFilterApplied = ops.enabled && !!ops.circleOL && !!ops.circle;
        this.filteredData = this.source.data.filter((user: EmployeeDataType) => {
            if (ops.enabled) {
                let loc = this.dataIdToOpenlayersLocation[user._internal_datasource_id_];
                let distance = Math.sqrt(Math.pow(ops.circleOL.x - loc.x, 2) + Math.pow(ops.circleOL.y - loc.y, 2));
                return distance < ops.circleOL.radius;
            } else {
                return true;
            }
        });
    }
}
